import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Star, Check } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { MAIN_SCREENS, CONFIG_SCREENS, screensFor } from "@/lib/mobile";
import { cardCls, blueBtn } from "@/components/mobile/parts";
import { cn } from "@/lib/utils";

const slug = (to) => to.split("/").pop();

function Tile({ s }) {
  const Icon = s.icon;
  return (
    <Link to={s.to} className={cn(cardCls, "flex flex-col items-center gap-1.5 p-3 text-center text-xs font-semibold leading-tight text-slate-700 active:scale-[0.97] transition-transform")} data-testid={`m-fav-${slug(s.to)}`}>
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#e3f2fd] text-[#1565c0]"><Icon className="h-5 w-5" /></span>{s.label}
    </Link>
  );
}

export function HomeFavorites() {
  const { session, setSession } = useAuth();
  const u = session.user;
  const all = [...screensFor(u, MAIN_SCREENS, session.tenant), ...CONFIG_SCREENS].filter((s) => s.to !== "/m");
  const favs = (u.mobile_favorites || []).map((to) => all.find((s) => s.to === to)).filter(Boolean);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState([]);
  const start = () => { setSel(u.mobile_favorites || []); setOpen(true); };
  const toggle = (to) => setSel((x) => (x.includes(to) ? x.filter((y) => y !== to) : x.length >= 12 ? x : [...x, to]));
  const save = async () => {
    try {
      const { data } = await api.put("/auth/me/mobile-favorites", { items: sel });
      setSession((s) => ({ ...s, user: { ...s.user, mobile_favorites: data.mobile_favorites } }));
      setOpen(false);
      toast.success("Favoritos salvos");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="space-y-3" data-testid="m-favorites">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-1.5 font-display font-semibold"><Star className="h-4 w-4 fill-amber-400 text-amber-400" />Favoritos</p>
        {favs.length > 0 && <button onClick={start} className="text-sm font-semibold text-[#1565c0]" data-testid="m-fav-edit-btn">Editar</button>}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {favs.map((s) => <Tile key={s.to} s={s} />)}
        <button onClick={start} className="flex min-h-[92px] flex-col items-center justify-center gap-1.5 rounded-2xl border-2 border-dashed border-slate-300 p-3 text-xs font-semibold text-slate-500 active:bg-slate-100" data-testid="m-fav-add-btn">
          <Plus className="h-5 w-5" />Adicionar favoritos
        </button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] max-w-sm overflow-y-auto" data-testid="m-fav-dialog">
          <DialogHeader><DialogTitle>Escolha seus atalhos</DialogTitle></DialogHeader>
          <ul className="space-y-1">
            {all.map((s) => {
              const on = sel.includes(s.to);
              const Icon = s.icon;
              return (
                <li key={s.to}>
                  <button onClick={() => toggle(s.to)} className={cn("flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm", on ? "bg-[#e3f2fd] font-semibold text-[#0d47a1]" : "hover:bg-slate-100")} data-testid={`m-fav-toggle-${slug(s.to)}`}>
                    <Icon className="h-5 w-5 text-[#1565c0]" /><span className="flex-1">{s.label}</span>{on && <Check className="h-4 w-4" />}
                  </button>
                </li>
              );
            })}
          </ul>
          <DialogFooter><Button className={cn("w-full", blueBtn)} onClick={save} data-testid="m-fav-save-btn">Salvar favoritos</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </section>
  );
}
